import store from '../store'

export const setEmailToStateFn = (email) => {
  if (email) {
    store.dispatch('setEmail', email)
  }
}
